var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login loading"},[_c('div',{staticClass:"loading-box"},[_c('div',{staticClass:"loading-wrap"},[_c('span',{staticClass:"dot dot-spin"},[_c('i'),_c('i'),_c('i'),_c('i')])])])])
}]

export { render, staticRenderFns }